import React from "react"
import { Provider } from "react-redux"
import { GoogleOAuthProvider } from "@react-oauth/google"

import { Login } from "./login"
import { store } from "./ducks"
import { getGoogleClientId } from "../helpers"

export const App = () => {
  return (
    <GoogleOAuthProvider clientId={getGoogleClientId() ?? ""}>
      <Provider store={store}>
        <Login />
      </Provider>
    </GoogleOAuthProvider>
  )
}
